// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TYnT","col":"styles_col__KOY2n"};